import { useState, createContext } from 'react'
import PropTypes from 'prop-types'
import {
  useReactTable,
  getCoreRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  getFilteredRowModel,
} from '@tanstack/react-table'

export const TanstackContext = createContext({})

export const TanstackContextProvider = ({
  children,
  data,
  columns,
  initialState = { pagination: { pageSize: 5000 } },
}) => {
  TanstackContextProvider.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    data: PropTypes.array,
    columns: PropTypes.array,
    initialState: PropTypes.object,
  }

  const [sorting, setSortingCols] = useState([])
  const [filtering, setFiltering] = useState('')

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    initialState,
    state: {
      sorting,
      globalFilter: filtering,
    },
    onSortingChange: setSortingCols,
    onGlobalFilterChange: setFiltering,
  })

  return (
    <TanstackContext.Provider value={{ table, sorting, filtering }}>
      {children}
    </TanstackContext.Provider>
  )
}
